import { Input } from '@/components/Input/Input'
import SearchIcon from '@mui/icons-material/Search'
import React, { useState } from 'react'
import styles from './Search.module.scss'
import { Button } from '@/ui'
import { useTranslation } from 'react-i18next'
import cl from 'classnames'
import { Download } from '@app/icons'

export const Search = ({
												 handleSearch,
												 handleImport,
											 }) => {
	const { t } = useTranslation()

	const [searchText, setSearchText] = useState('')

	const handleReset = () => {
		setSearchText('')
		handleSearch('')
	}

	return (
		<div className={styles.wrapper}>
			<Input
				prefix={<SearchIcon />}
				containerClassName={styles.inputClass}
				placeholder={t('sickLeave.search_placeholder')}
				onChange={(e) => setSearchText(e.target.value)}
				value={searchText}
			/>

			<Button onClick={() => handleSearch(searchText)}>
				{t('find')}
			</Button>

			<Button type="bare" onClick={handleReset}>
				{t('electronic_contract.reset')}
			</Button>

			<div
				style={{ cursor: 'pointer' }}
				className={cl('flex', 'align-center', 'gap-3')}
				onClick={handleImport}>
				<Download />
				{t('labor_records.export')}
			</div>
		</div>
	)
}